import { NavLink, useLocation } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { cn } from "../utils";

export interface Tab {
  to: string;
  label: string;
  icon?: LucideIcon;
  end?: boolean;
  /** Additional path prefixes that should also activate this tab */
  alsoMatches?: string[];
}

interface TabsProps {
  tabs: Tab[];
  className?: string;
}

export function Tabs({ tabs, className }: TabsProps) {
  const location = useLocation();

  return (
    <div
      className={cn(
        "flex items-center gap-1 bg-slate-100 rounded-lg p-1",
        className
      )}
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        // Check if current path matches any of the alsoMatches patterns
        const matchesAlso = tab.alsoMatches?.some((pattern) =>
          location.pathname.startsWith(pattern)
        );

        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors",
                isActive || matchesAlso
                  ? "bg-white text-slate-900 shadow-sm"
                  : "text-slate-600 hover:text-slate-900"
              )
            }
          >
            {Icon && <Icon className="w-4 h-4" />}
            {tab.label}
          </NavLink>
        );
      })}
    </div>
  );
}
